/**
 * **쪽을 따라 목록을 끝까지 읽는다 — 한 곳**(D-109). 목록(프로젝트·실행 기록·사용자 프로필)의 «전부» 는 여기서 정한다. 실행 기록을 첫
 * 쪽에서 멈추던 동안 오래된 실행이 화면에서 사라지고 개수가 쪽 크기에서 멈췄다(6차 베타 2026-10-15: 실행 목록 «이력 50» 인데 실제 70건).
 * 같은 쪽 표지가 되풀이되면 끝없이 돌지 않고 실패로 알린다 — 전에는 프로필 목록이 따로 둔 루프에 이 보호가 없었다.
 */

/** BFF 가 목록 한 쪽에 싣는 최대 — 프로젝트·실행 기록·프로필이 같다(vsmr-sim-bff project_manager_server.py:329·728,
 *  user_profile_server.py:299 `min(page_size, 200)`). 끝까지 읽을 때 쪽 수를 줄인다 */
export const LIST_PAGE_SIZE = 200;

export async function readAllPages<T>(fetchPage: (pageToken: string) => Promise<{ entries: T[]; nextPageToken: string }>): Promise<T[]> {
  const all: T[] = [];
  const seen = new Set<string>();
  let pageToken = '';
  do {
    seen.add(pageToken);
    const page = await fetchPage(pageToken);
    all.push(...page.entries);
    pageToken = page.nextPageToken;
    if (pageToken && seen.has(pageToken)) throw new Error(`목록의 쪽 표지가 되풀이된다: ${pageToken}`);
  } while (pageToken);
  return all;
}
